// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2H9lJ","modalFooterButton":"ModalNotes_modalFooterButton__19fq2"};